import { FiRefreshCw, FiCalendar, FiSun, FiClock } from "react-icons/fi";

export const RECURRENCE_TYPES = [
  { value: "daily",   label: "Daily",   icon: FiSun,        description: "Repeats every day or every N days" },
  { value: "weekly",  label: "Weekly",  icon: FiRefreshCw,  description: "Repeats on selected days each week" },
  { value: "monthly", label: "Monthly", icon: FiCalendar,   description: "Repeats on a specific day each month" },
  { value: "yearly",  label: "Yearly",  icon: FiClock,      description: "Repeats once a year" },
  { value: "custom",  label: "Custom",  icon: FiRefreshCw,  description: "Repeats every N days" },
];

export const WEEK_DAYS = [
  { value: 0, label: "Sun", full: "Sunday" },
  { value: 1, label: "Mon", full: "Monday" },
  { value: 2, label: "Tue", full: "Tuesday" },
  { value: 3, label: "Wed", full: "Wednesday" },
  { value: 4, label: "Thu", full: "Thursday" },
  { value: 5, label: "Fri", full: "Friday" },
  { value: 6, label: "Sat", full: "Saturday" },
];

export const NTH_OPTIONS = [
  { value: 1,  label: "First" },
  { value: 2,  label: "Second" },
  { value: 3,  label: "Third" },
  { value: 4,  label: "Fourth" },
  { value: -1, label: "Last" },
];

export const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

export const END_TYPES = [
  { value: "never", label: "Never" },
  { value: "on",    label: "On a specific date" },
  { value: "after", label: "After N occurrences" },
];

export const TASK_STATUS_OPTIONS = [
  { value: 1, label: "To Do",       color: "#475569", bg: "#F1F5F9" },
  { value: 2, label: "In Progress", color: "#0F766E", bg: "#CCFBF1" },
  { value: 3, label: "Completed",   color: "#15803D", bg: "#DCFCE7" },
];

export const PRIORITY_OPTIONS = [
  { value: 1, label: "Low",    color: "#059669", bg: "#ECFDF5" },
  { value: 2, label: "Medium", color: "#D97706", bg: "#FFFBEB" },
  { value: 3, label: "High",   color: "#DC2626", bg: "#FEF2F2" },
];

export const STATUS_COLORS = {
  active:   { bg: "#DCFCE7", color: "#15803D", label: "Active" },
  paused:   { bg: "#FEF3C7", color: "#92400E", label: "Paused" },
  archived: { bg: "#F1F5F9", color: "#475569", label: "Archived" },
};

/** Human-readable summary of a template's recurrence pattern */
export function recurrenceSummary(template) {
  const {
    recurrenceType: type,
    recurrenceInterval: interval = 1,
    recurrenceDaysOfWeek: daysOfWeek = [],
    recurrenceDayOfMonth: dayOfMonth,
    recurrenceNthWeekday: nth,
    recurrenceMonth: month,
    monthlyMode,
  } = template;

  switch (type) {
    case "daily":
      return interval === 1 ? "Every day" : `Every ${interval} days`;
    case "weekly": {
      const names = daysOfWeek.map((d) => WEEK_DAYS[d]?.label).join(", ");
      return interval === 1
        ? `Every week on ${names}`
        : `Every ${interval} weeks on ${names}`;
    }
    case "monthly": {
      // Mirror the server: monthlyMode decides, presence only as a fallback for
      // templates saved before the field existed.
      const hasNth = nth?.n != null && nth?.d != null;
      if ((monthlyMode || (hasNth ? "nth" : "fixed")) === "nth" && hasNth) {
        const nthLabel  = NTH_OPTIONS.find((o) => o.value === nth.n)?.label || "";
        const dayLabel  = WEEK_DAYS[nth.d]?.full || "";
        return `${nthLabel} ${dayLabel} of every month`;
      }
      return `Day ${dayOfMonth} of every month`;
    }
    case "yearly":
      return `Every year in ${MONTHS[month] || ""} on day ${dayOfMonth}`;
    case "custom":
      return `Every ${interval} days`;
    default:
      return "—";
  }
}
